module.exports = __webpack_public_path__ + "media/volvo/assets/images/hero_background@2x-41c1fa8ae64665d99c0877a228fc149d.jpg";